import { observer } from "mobx-react-lite";
import { useFormikContext } from "formik";
import { useMemo } from "react";
import { useTran } from "@/hooks";
import { SelectField } from "@/components/common";
import { INDUSTRIAL_CLASSIFICATION } from "@/lib/constants";
import {
  INDUSTRY_VALUE_MAP,
  translateValue,
} from "@/lib/constants/translations.map";

const CompanySetupStepTwo = observer(() => {
  const { t, i18n } = useTran();
  const { values, touched, errors, setFieldValue, setFieldTouched } =
    useFormikContext();

  const getFieldError = (key) => (touched?.[key] ? errors?.[key] : undefined);

  const handleIndustryChange = (event) => {
    const nextValue = event?.target?.value || "";
    setFieldValue("industry", nextValue, true);
    setFieldTouched("industry", true, false);
  };

  const industryOptions = useMemo(
    () =>
      INDUSTRIAL_CLASSIFICATION.map((option) => ({
        key: option.key,
        value: translateValue(option.value, INDUSTRY_VALUE_MAP, i18n.language),
      })),
    [i18n.language],
  );

  return (
    <div className="space-y-6">
      <SelectField
        id="industry"
        label={t("industry_question")}
        required
        placeholder={t("select_industry")}
        value={values.industry}
        options={industryOptions}
        onChange={handleIndustryChange}
        error={getFieldError("industry")}
      />
    </div>
  );
});

export default CompanySetupStepTwo;
